// src/index.ts
import { initContract as initContract3 } from "@ts-rest/core";

// src/v1/providers.ts
import { initContract } from "@ts-rest/core";
import { z as z2 } from "zod";

// src/v1/types.ts
import { z } from "zod";
var FederatedIdentityRepresentationSchema = z.object({
  identityProvider: z.string().optional(),
  userId: z.string().optional(),
  userName: z.string().optional()
});
var IdentityProviderRepresentationSchema = z.object({
  addReadTokenRoleOnCreate: z.boolean().optional(),
  alias: z.string().optional(),
  config: z.record(z.string(), z.any()).optional(),
  displayName: z.string().optional(),
  enabled: z.boolean().optional(),
  firstBrokerLoginFlowAlias: z.string().optional(),
  hasStorage: z.boolean().optional(),
  internalId: z.string().optional(),
  linkOnly: z.boolean().optional(),
  postBrokerLoginFlowAlias: z.string().optional(),
  providerId: z.string().optional(),
  storeToken: z.boolean().optional(),
  trustEmail: z.boolean().optional()
});

// src/v1/providers.ts
var c = initContract();
var providersContract = c.router(
  {
    getAll: {
      method: "GET",
      path: `/`,
      headers: z2.object({
        authorization: z2.string().optional()
      }).optional(),
      responses: {
        200: z2.array(IdentityProviderRepresentationSchema),
        500: c.type()
      },
      summary: "Get identity providers"
    }
  },
  {
    pathPrefix: "/providers"
  }
);

// src/v1/users.ts
import { initContract as initContract2 } from "@ts-rest/core";
import { z as z3 } from "zod";
var c2 = initContract2();
var usersContract = c2.router(
  {
    getLinkedAccounts: {
      method: "GET",
      path: `/:username/linked-accounts`,
      headers: z3.object({
        authorization: z3.string()
      }),
      responses: {
        200: z3.array(FederatedIdentityRepresentationSchema),
        401: c2.type(),
        404: c2.type(),
        500: c2.type()
      },
      summary: "Get user linked accounts"
    },
    getLinkAccountUrl: {
      method: "GET",
      path: `/:username/link-account-url`,
      headers: z3.object({
        authorization: z3.string()
      }),
      query: z3.object({
        /**
         * @type {string} - The indentity provider to link.
         */
        provider: z3.string(),
        /**
         * @type {string} - The URL to redirect to after linking.
         * Usually the URL from where the call was originated.
         * Or the website root.
         */
        redirectUri: z3.string()
      }),
      responses: {
        200: z3.object({ url: z3.string() }),
        401: c2.type(),
        404: c2.type(),
        500: c2.type()
      },
      summary: "Get url to link the provider to the user account"
    }
  },
  {
    pathPrefix: "/users"
  }
);

// src/index.ts
var c3 = initContract3();
var contract = c3.router({
  v1: c3.router(
    {
      providers: providersContract,
      users: usersContract
    },
    {
      pathPrefix: "/v1",
      strictStatusCodes: true
    }
  )
});
export {
  FederatedIdentityRepresentationSchema,
  IdentityProviderRepresentationSchema,
  contract
};
